<template>
  <div class="customers">

    <div class="title-button">

      <h1>Customers</h1>

      <div>
        <button class="button button--small" type="button" @click="showBrochureLookUp = true">
          <span>Lookup brochure request</span>
        </button>
        <router-link to="/customers/create" class="button p-3" v-if="userRole==1">New customer</router-link> 
        &nbsp;
        <router-link to="/customers/duplicate-customers" class="btn btn-warning" v-if="userRole==1">Manage customers</router-link>
      </div>
    </div>

    <div class="box">

      <div class="table__header">

        <form @submit.stop.prevent="doSearch" class="box__header form--inline">
          <input v-model="quickSearch" type="text" placeholder="Post Code">
          &nbsp;&nbsp;
          <input v-model="openSearch" type="text" placeholder="Open search">
          &nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;
          <button class="button button--small" type="submit"><span>Search</span></button>
        </form>

        <div class="table__buttons">
          <button class="button button--neutral" @click.stop.prevent="doExport('csv')"><span>Export CSV</span></button>
        </div>

      </div>
      <hr/>
      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="options"
        @edit="doAlertEdit"
        :key="customerTableKey"
        >
      </vdtnet-table>

    </div><!-- box -->
    <div class="modal" v-if="showBrochureLookUp">
      <h1>Search Brochure Requests</h1>
      <div class="box">

        <div class="table__header">

          <form @submit.stop.prevent="doBrochureRequestSearch" class="box__header form--inline">
            <!-- <input v-model="brochureRequestQuickSearch" type="search" placeholder="Quick search">
            <button class="button button--small" type="submit"><span>Search</span></button> -->
            <v-select
              :options="brochurerequestSearchOption.availableBrochures"
              label="brochure_name"
              placeholder="Search by brochure."
              id="search_by_brochure"
              index="id"
              v-model="brochurerequestSearchOption.brochure_id"
            />
            &nbsp;&nbsp;
          <input v-model="brochurerequestSearchOption.customerSearch" type="search" placeholder="Search by customer.">
          <input v-model="brochurerequestSearchOption.batchIdSearch" type="search" placeholder="Search by batch ID.">
          <input v-model="brochurerequestSearchOption.customerPostCode" type="search" placeholder="Search by Pincode.">
          <dateTimePicker
            class="ms-2"
            no-label
            label="Requested From"
            format="YYYY-MM-DD"
            formatted="YYYY-MM-DD"
            :only-date="true"
            button-color="#ec391e"
            color="#ec391e"
            style="border: 1px solid #DFE5F9"
            v-model="brochurerequestSearchOption.brochureRequestedFrom"
          />
          <dateTimePicker
            class="ms-2"
            no-label
            label="Requested To"
            format="YYYY-MM-DD"
            formatted="YYYY-MM-DD"
            :only-date="true"
            button-color="#ec391e"
            color="#ec391e"
            style="border: 1px solid #DFE5F9"
            v-model="brochurerequestSearchOption.brochureRequestedTo"
          />
          <button class="button button--large ms-2" type="submit"><span>Search</span></button>
          </form>
        </div>

        <vdtnet-table
          ref="brochureRequestTable"
          :fields="brochureRequestFields"
          :opts="brochureRequestOptions"
          @create-customer="customerFromBrochureRequest"
          :key="brochuresTableKey"
        >
        </vdtnet-table>

      </div><!-- box -->
      <button type="button" class="icon icon--unlink" @click="showBrochureLookUp = false">Close</button>
    </div>
  </div>
</template>

<script>
import 'datatables.net'
import VdtnetTable from 'vue-datatables-net'
import axios from 'axios'

export default {
  name: 'customers',
  components: {
    VdtnetTable,
  },
  computed: {
    userRole() {
      return localStorage.getItem("user_role");
    }
  },
  data() {
    return {
      options: {
        ajax: {
          url: this.$api + 'customers/table',
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          },
          dataSrc: (data) => {
            this.showAlertConfirmation(data);
            return data.data;
          }
        },
        responsive: false,
        processing: true,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        ordering: true,
        lengthChange: true,
        serverSide: true,
        dom: 'rtlip',
        autoWidth: false,
        lengthMenu: [ [25, 50, 100, 500], [25, 50, 100, 500] ],
        pageLength: 25,
        order: [[4, 'desc']],
      },
      fields: {
        last_name: {
          label: 'Last Name',
          // defaultOrder: 'asc'
        },
        first_name: {
          label: 'First Name',
          render: (d, t, f) => {
            return `${d} ${(f.is_blacklisted) ? '( Blacklisted )' : ''}`
          }
        },
        email: { label: 'Email',
          render: (data) => {
            return (data !== null ? `<a target="_blank" href="mailto://${ data }">${ data }</a>` : '')
          }
        },
        phone_number: { label: 'Telephone'},
        postcode: { label: 'Postcode'},
        actions: {
          searchable: false,
          sortable: false,
          label: ' ',
          render: (data, type, row) => {
            return `<a href="/customers/edit/${ row.id }" data-action="edit" class="icon icon--more">Edit</a>`
          }
        }
      },
      quickSearch: '',
      openSearch:'',
      showBrochureLookUp: false,
      brochureRequestQuickSearch: '',
      brochureRequestOptions: {
        ajax: {
          url: this.$api + 'customers/brochure-request-table',
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          },
          dataSrc: (data) => {
            this.brochureConfirmation(data);
            return data.data;
          }
        },
        responsive: false,
        processing: true,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        ordering: false,
        lengthChange: true,
        serverSide: true,
        dom: 'rtlip',
        autoWidth: false,
        lengthMenu: [ [5, 25, 50, 100, 500], [5, 25, 50, 100, 500] ],
        pageLength: 25,
        select: {
          style: 'multi'
        }
      },
      brochureRequestFields: {
        'brochures_names': {
          label: 'Brochure',
          render: (data) => {
            if(data !== null) {
              return `${ data }`
            } else {
              return '-'
            }
          }
        },
        'customer_name': {
          label: 'Customer Name',
          render: (data) => {
            if(data !== null) {
              return `${ data ? data : '-' }`
            } else {
              return '-'
            }
          }
        },
        'brochure_requester_name': {
          label: 'Requester Name',
          render: (data) => {
            if(data !== null) {
              return `${ data ? data : '-' }`
            } else {
              return '-'
            }
          }
        },
        'brochure_requester.postcode': {
          label: 'Requester Postcode',
          render: (data) => {
            if(data !== null) {
              return `${ data ? data : '-' }`
            } else {
              return '-'
            }
          }
        },
        actions: {
          searchable: false,
          sortable: false,
          label: 'Action',
          render: () => {
            if (this.userRole == 1) {
              return `<a href="javascript:void(0);" data-action="create-customer" class="">Create Customer</a>`
            } else {
              return '--'
            }
          }
        }
      },
      brochurerequestSearchOption:{
        availableBrochures:[],
        brochure_id:null, 
        customerSearch:null,
        batchIdSearch:null,
        brochureRequestedFrom:null,
        brochureRequestedTo:null,
        customerPostCode:null
      },
      brochuresTableKey: 0,
      customerTableKey: 0, // Key attribute to force re-render of the table,
    }
  },
  mounted(){
    this.getBrochures()
  },
  methods: {
    doSearch() {
      // this.$refs.table.search(this.quickSearch)
      const ajaxUrl = this.$api + 'customers/table'

      const queryString = new URLSearchParams();

      if(this.quickSearch) {
        queryString.set('pincode_search', this.quickSearch);
      }

      if(this.openSearch){
        queryString.set('open_search', this.openSearch);
      }

      const urlWithParams = `${ajaxUrl}?${queryString.toString()}`;

      // Update the datatable's AJAX URL with the Start Date & End Date query parameters
      this.options.ajax.url = urlWithParams;

      // Increment the tableKey to force re-render and fetch new data
      this.customerTableKey++;
    },
    doAlertEdit(data) {
      this.$router.push({ name: 'customer-edit', params: { id: data.id }})
    },
    doExport(type) {
      const parms = this.$refs.table.getServerParams()
      parms.export = type
      // window.alert('GET /api/v1/export?' + jQuery.param(parms))
    },
    doBrochureRequestSearch() {
      
      // this.$refs.brochureRequestTable.search(this.brochureRequestQuickSearch)
      const ajaxUrl = this.$api + 'customers/brochure-request-table'

      const queryString = new URLSearchParams();
      if(this.brochurerequestSearchOption.brochure_id) {
        queryString.set('brochure_name', this.brochurerequestSearchOption.brochure_id);
      }

      if(this.brochurerequestSearchOption.customerSearch){
        queryString.set('customer_name', this.brochurerequestSearchOption.customerSearch);
      }

      if(this.brochurerequestSearchOption.batchIdSearch){
        queryString.set('batch_id', this.brochurerequestSearchOption.batchIdSearch);
      }

      if(this.brochurerequestSearchOption.brochureRequestedFrom){
        queryString.set('brochure_requested_from', this.brochurerequestSearchOption.brochureRequestedFrom);
      }

      if(this.brochurerequestSearchOption.brochureRequestedTo){
        queryString.set('brochure_requested_to', this.brochurerequestSearchOption.brochureRequestedTo);
      }
      if(this.brochurerequestSearchOption.customerPostCode){
        queryString.set('customer_post_code', this.brochurerequestSearchOption.customerPostCode);
      }

      const urlWithParams = `${ajaxUrl}?${queryString.toString()}`;
      
      // Update the datatable's AJAX URL with the Start Date & End Date query parameters
      this.brochureRequestOptions.ajax.url = urlWithParams;

      // Increment the tableKey to force re-render and fetch new data
      this.brochuresTableKey++;
    },
    customerFromBrochureRequest(data) {
      console.log(data, 'sasas');
      this.$dialog
      .confirm({
        title: "Are you sure you want to create a new customer?",
        body: "HEADS UP: Before creating a new customer out of this brochure request, please make sure if a customer already exists, and in that case you can link that customer only to prevent duplication.",
      })
      .then(() => {
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'brochures/requests/' + data.id + '/create-customer', {
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          console.log(response, 'res')
          this.$store.dispatch('setLoadStatus')
          if(response.success == true) {
            this.$notify({
              type: 'success',
              title: response.message
            });
            this.$router.push({ name: 'customer-edit', params: { id: response.data }})
          } else {
            this.$notify({
              type: 'error',
              title: response.message
            });
          }
        })
      })
      .catch(() => {
        console.log('clicked on cancel');
      });
    },
    showAlertConfirmation(result) {
      if(result.data.length === 0) {
        // this.$dialog
        // .confirm("No customer matching records found, Do you want to lookup brochure request")
        // .then(() => {
        //   this.brochureRequestQuickSearch = this.quickSearch;
        //   this.showBrochureLookUp = true;
        //   this.$nextTick(() => {
        //     // After the Ajax request has completed, perform an initial search
        //     this.doBrochureRequestSearch();
        //   })
        // })
        // .catch(() => {
        //   console.log('clicked on cancel');
        // });
          if (!this.openSearch) {
            this.brochurerequestSearchOption.customerPostCode = this.quickSearch;
            this.showBrochureLookUp = true;
            this.$nextTick(() => {
              // After the Ajax request has completed, perform an initial search
              this.doBrochureRequestSearch();
            })
          }
      }
    },
    brochureConfirmation(result){
      if(result.data.length === 0) {
        console.log('No brochure Request Found')
        this.$router.push({name:'create-new-customer',query: { postcode: this.brochurerequestSearchOption.customerPostCode } })
      }
    },
    getBrochures() {
      axios
        .get(this.$api + "brochure-list?type=active")
        .then((res) => res.data)
        .then((response) => {
          this.brochurerequestSearchOption.availableBrochures = response.data;
          if (this.brochurerequestSearchOption.availableBrochures.length > 0) {
            this.brochurerequestSearchOption.availableBrochures = this.brochurerequestSearchOption.availableBrochures.slice().sort((a, b) => {
              return a.brochure_name.localeCompare(b.brochure_name);
            });
          }
        });
    },
  }
}

</script>
